import React from "react";
import styles from "./normal.module.css";

export const NormalText = ({ children,align="left",size }) => {
  return <div style={{textAlign:align,fontSize:size}} className={`${styles.text}`}>{children}</div>;
};

export const BoldText = ({ children,align="left",size }) => {
  return <div style={{textAlign:align,fontStyle:'inherit',fontSize:size,fontWeight:600}} className={`${styles.text}`}>{children}</div>;
};